export default "__VITE_ASSET__Dmxka7te__"